module.exports = __webpack_public_path__ + "img/100_dice[6].d68035fe.png";